/**
 * Cloudflare Turnstile configuration.
 *
 * A Secret Key fica configurada no Supabase Dashboard:
 *   Authentication → Settings → Bot Protection → Turnstile
 *
 * A Site Key abaixo é pública e pode ficar no frontend.
 */
const RAW_SITE_KEY = '0x4AAAAAADYIoyk6-MB_5BXC';

export const TURNSTILE_SITE_KEY = RAW_SITE_KEY;

// Compat: mantém nome antigo para imports legados
export const HCAPTCHA_SITE_KEY = RAW_SITE_KEY;

/**
 * Detecta ambientes onde o Turnstile não funciona (preview do Lovable,
 * `*.lovable.app` em geral, iframes do editor). Nesses casos desativamos o
 * captcha para não bloquear o login durante o desenvolvimento.
 *
 * A proteção continua ativa apenas no domínio customizado de produção
 * (`cursodanielluiz.com.br` e subdomínios, ex.: `plataforma.cursodanielluiz.com.br`).
 */
function isCaptchaSupportedHost(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const host = window.location.hostname;
    if (host === 'cursodanielluiz.com.br') return true;
    if (host.endsWith('.cursodanielluiz.com.br')) return true;
    return false;
  } catch {
    return false;
  }
}


export const CAPTCHA_ENABLED =
  RAW_SITE_KEY.trim().length > 0 && isCaptchaSupportedHost();
